$('.slider-reviews').slick({
  infinite: false,
  dots: true,
  arrows: false,
  slidesToShow: 1,
});
